import React from "react";
import { useTranslation } from "react-i18next";
import { ButtonBase, ButtonIconTrash, InputAutoresize } from "../../../common/components/form";
import slug from "../../../common/lib/slug.js";

const ITEMS_MAX = 5;
export default function WStep10Footer(props) {
    const { t } = useTranslation();

    const {
        set,
        variables: { OfficialWebsiteLink, Legacy },
    } = props;

    const _Legacy = Legacy || [{}];

    function onOfficialWebsiteLinkChange(type, value) {
        set({ OfficialWebsiteLink: { ...OfficialWebsiteLink, [type]: value } });
    }

    function onItemChange({ index, name, value }) {
        const nl = [..._Legacy];

        if (nl[index]) {
            nl[index][name] = value;

            if (name === "title") {
                nl[index].link = `/${slug(value)}`;
            }
        }

        set({ Legacy: nl });
    }

    function onItemRemove(index) {
        set({ Legacy: [..._Legacy].filter((_, i) => i !== index) });
    }

    function onAddClick() {
        set({ Legacy: [..._Legacy, {}] });
    }

    const list = _Legacy || [{}];

    return (
        <div className="wizard-part-inner">
            <div style={{ flex: 1 }}>
                <h1>{t("WizardWStep10Header")}</h1>

                <div className="margin-top-40 grid-gap-20">
                    <div className="grid-gap-20">
                        <h2>{t("WizardWStep10OfficialWebsiteLinkHeader")}</h2>
                        <p>{t("WizardWStep10OfficialWebsiteLinkTest")}</p>
                    </div>

                    <InputAutoresize
                        name="OfficialWebsiteLinkText"
                        onChange={({ target: { value } }) => onOfficialWebsiteLinkChange("text", value)}
                        value={OfficialWebsiteLink?.text || ""}
                        placeholder={t("WizardWStep10OfficialWebsiteLinkTextInputPlaceholder")}
                    />

                    <InputAutoresize
                        name="OfficialWebsiteLinkUrl"
                        onChange={({ target: { value } }) => onOfficialWebsiteLinkChange("url", value)}
                        value={OfficialWebsiteLink?.url || ""}
                        placeholder={t("WizardWStep10OfficialWebsiteLinkUrlInputPlaceholder")}
                    />
                </div>

                <div className="margin-top-40 grid-gap-40">
                    <div className="grid-gap-20">
                        <h2>{t("WizardWStep10LegacyHeader")}</h2>
                        <p>{t("WizardWStep10LegacyText")}</p>
                    </div>

                    {list.map((item, index) => (
                        <div key={index} className="grid-gap-20 relative wizard-footer">
                            <div className="wizard-footer-input-with-delete">
                                <InputAutoresize
                                    name="title"
                                    onChange={({ target: { name, value } }) => onItemChange({ index, name, value })}
                                    value={item?.title || ""}
                                    placeholder={t("WizardWStep10MenuLinkTitleFooter")}
                                />

                                <div className="absolute" style={{ top: 0, left: "calc(100% + 20px)" }}>
                                    <ButtonIconTrash
                                        noMargin
                                        disabled={list.length < 2}
                                        onClick={() => onItemRemove(index)}
                                    />
                                </div>
                            </div>

                            <div>
                                <InputAutoresize
                                    multirow
                                    name="text"
                                    className="w600px-responsive"
                                    onChange={({ target: { name, value } }) => onItemChange({ index, name, value })}
                                    value={item?.text || ""}
                                    placeholder={t("WizardWStep10PutYourFormattedTextHere")}
                                    style={{ minHeight: "100px" }}
                                />
                            </div>
                        </div>
                    ))}
                </div>

                {list.length < ITEMS_MAX && (
                    <div className="margin-top-40">
                        <ButtonBase onClick={onAddClick}>{t("PlusAdd")}</ButtonBase>
                    </div>
                )}
            </div>
        </div>
    );
}
